export const unreachableWithReturn = <T>(_: never, value: T): T => {
  return value;
};
